const FlowTmpl = () => import('@/views/flow/tmpl/index.vue');
const matterFlow = () => import('@/views/flow/tmpl/matterFlow.vue');
const FlowTmplRecord = () => import('@/views/flow/tmpl/indexRecord.vue');
const FlowDeploy = () => import('@/views/flow/deploy/index.vue');
const FlowTask = () => import('@/views/flow/task/index.vue');
const FlowAssistTask = () => import('@/views/flow/task/assistIndex.vue');
const FlowDiagram = () => import('@/views/flow/diagram/index.vue');

const HisFlowInstance = () => import('@/views/flow/history/instance/index.vue');

const FlowNode = () => import('@/views/flow/deploy/flowNode/flowNode.vue');

const FlowNodeCc = () => import('@/views/flow/deploy/flowNodeCc/index.vue');

const condition = () => import('@/views/flow/condition/index.vue');
// 设置流程条件
const setCondition = () => import('@/views/flow/condition/setCondition/index.vue');

const userParamConf = () => import('@/views/flow/userParamConf/index.vue');

const result = () => import('@/views/flow/result/index.vue');

const moduleSet = () => import('@/views/flow/deploy/moduleSet/index.vue');

const taskEditset = () => import('@/views/flow/history/taskEditset/index.vue');

//流程实例项目详情
const projectInfoLayout = () => import('@/components/projectInfoLayout/page.vue');

const consignConf = () => import('@/views/flow/consign/index.vue');

const baseFlowLayout = () => import('@/components/baseFlowLayout/page.vue');
const baseFlowLayoutDisplay = () => import('@/components/baseFlowLayout/pageDisplay.vue');


export default [
  {
    path: '/flow/projectInfoLayout',
    name: 'projectInfoLayout',

    component: projectInfoLayout
  },
  {
    path: '/flow/tmpl',
    name: 'FlowTmpl',
    meta: {
      title: '流程模板',
      path: ['流程管理', '流程模板'],
      icon: 'dashboard',
      noCache: false,
      affix: true
    },
    component: FlowTmpl
  },
  {
    path: '/flow/matterFlow',
    name: 'matterFlow',
    meta: {
      title: '事项流程',
      icon: 'dashboard',
      noCache: false,
      affix: true
    },
    component: matterFlow
  },
  {
    path: '/flow/tmplRecord',
    name: 'FlowTmplRecord',
    meta: {
      title: '流程模板记录',
      path: ['流程管理', '流程模板记录'],
      icon: 'dashboard',
      noCache: false,
      affix: true
    },
    component: FlowTmplRecord
  },

  {
    path: '/flow/deploy',
    name: 'FlowDeploy',
    meta: {
      title: '已发布流程',
      path: ['流程管理', '已发布流程'],
      icon: 'dashboard',
      noCache: true,
      affix: true
    },
    component: FlowDeploy
  },

  {
    path: '/flow/his/instance',
    name: 'HisFlowInstance',
    meta: {
      title: '我的已办',
      path: ['工作台', '我的已办'],
      icon: 'dashboard',
      noCache: true,
      affix: true
    },
    component: HisFlowInstance
  },
  {
    path: '/flow/task',
    name: 'FlowTask',
    meta: {
      title: '我的待办',
      path: ['工作台', '我的待办'],
      icon: 'dashboard',
      noCache: true,
      affix: true
    },
    component: FlowTask
  },
  {
    path: '/flow/assistTask',
    name: 'FlowAssistTask',
    meta: {
      title: '我的协办',
      path: ['工作台', '我的协办'],
      icon: 'dashboard',
      noCache: true,
      affix: true
    },
    component: FlowAssistTask
  },
  {
    path: '/flow/taskcc',
    name: 'FlowNodeCc',
    meta: {
      title: '抄送我的',
      path: ['我的任务', '抄送我的'],
      icon: 'dashboard',
      noCache: true,
      affix: true
    },
    component: FlowNodeCc
  },
  {
    path: '/flow/diagram',
    name: 'FlowDiagram',
    meta: {
      title: '流程任务',
      icon: 'dashboard',
      noCache: true,
      affix: true
    },
    component: FlowDiagram
  },
  {
    path: '/flow/deploy/FlowNode',
    name: 'FlowNode', //发布流程节点
    component: FlowNode
  },
  // {
  //   path: '/flow/business',
  //   name: 'business',
  //   meta: {
  //     title: '业务办理',
  //     icon: 'dashboard',
  //     noCache: true,
  //     affix: true
  //   },
  //   component: business
  // },
  {
    path: '/flow/condition',
    name: 'condition',
    meta: {
      title: '流程中条件',
      path: ['流程管理', '流程中条件'],
      icon: 'dashboard',
      noCache: true,
      affix: true
    },
    component: condition
  },
  {
    path: '/flow/setCondition',
    name: 'setCondition',
    meta: {
      title: '条件配置',
      path: ['流程管理', '流程条件设置'],
      icon: 'dashboard',
      noCache: true,
      affix: true
    },
    component: setCondition
  },
  {
    path: '/flow/userParamConf',
    name: 'userParamConf',
    meta: {
      title: '设置流程用户',
      path: ['流程管理', '设置流程用户'],
      icon: 'dashboard',
      noCache: true,
      affix: true
    },
    component: userParamConf
  },
  // {
  //   path: '/flow/demo',
  //   name: 'demo',
  //   meta: {
  //     title: '测试表单',
  //     path: ['流程管理', '测试表单'],
  //     icon: 'dashboard',
  //     noCache: true,
  //     affix: true
  //   },
  //   component: demo
  // },

  {
    path: '/flow/deploy/moduleSet',
    name: 'moduleSet',
    meta: {
      title: '模块设置',
      path: ['流程管理', '模块设置'],
      icon: 'dashboard',
      noCache: true,
      affix: true
    },
    component: moduleSet
  },
  {
    path: '/flow/result',
    name: 'result',
    meta: {
      title: '结论设置',
      path: ['流程管理', '结论设置'],
      icon: 'dashboard',
      noCache: true,
      affix: true
    },
    component: result
  },
  {
    path: '/flow/myFinished',
    name: 'taskEditset',
    meta: {
      title: '我的已办',
      path: ['流程管理', '我的已办'],
      icon: 'dashboard',
      noCache: true,
      affix: true
    },
    component: taskEditset
  },

  {
    path: '/flow/consignConf',
    name: 'consignConf',
    meta: {
      title: '移交办理配置',
      path: ['流程管理', '移交办理配置'],
      icon: 'dashboard',
      noCache: true,
      affix: true
    },
    component: consignConf
  }
];
